import { CoaAppConfig } from './types';

export const appConfig: CoaAppConfig = {
  enableMembership: Boolean(process.env.ENABLE_MEMBERSHIP),
  enableMyCoaV2: Boolean(process.env.ENABLE_MY_COA_V2),
  enableClassMarketplaceV2: Boolean(process.env.ENABLE_CLASS_MARKETPLACE_V2),
  enableCoaDevTools: Boolean(process.env.ENABLE_COA_DEV_TOOLS),
};
